import backofficeService from '../../api/backoffice'

export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getAll(params) {
    return backofficeService.Api().get('zakatAllocation', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get specific zakatAllocation
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to zakatAllocation
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`zakatAllocation/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  
  /**
   * Create a zakatAllocation. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('zakatAllocation', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Update specific zakatAllocation
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`zakatAllocation/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Delete zakatAllocation
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`zakatAllocation/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

}
